<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 6}" :lg="{span: 12}">
          <el-form-item
            :label="$l('form_label_containerName') || '箱型名称'"
            prop="containerName"
          >
            <el-input
              clearable
              v-model="formData.containerName"
              :placeholder="
                $l('INDEX.tips_input_placeholder') || '请输入箱型名称'
              "
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{span: 24}" :md="{span: 6}" :lg="{span: 12}">
          <el-form-item
            :label="$l('form_label_containerDesc') || '箱型说明'"
            prop="containerDesc"
          >
            <el-input
              clearable
              v-model="formData.containerDesc"
              :placeholder="
                $l('INDEX.tips_input_placeholder') || '请输入箱型说明'
              "
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 6}" :lg="{span: 12}">
          <el-form-item
            :label="$l('form_label_containerLength') || '内径长'"
            prop="containerLength"
          >
            <el-input-number
              clearable
              v-model="formData.containerLength"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width:100%;"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{span: 24}" :md="{span: 6}" :lg="{span: 12}">
          <el-form-item
            :label="$l('form_label_containerWidth') || '内径宽'"
            prop="containerWidth"
          >
            <el-input-number
              clearable
              v-model="formData.containerWidth"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width:100%;"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 6}" :lg="{span: 12}">
          <el-form-item
            :label="$l('form_label_containerHeight') || '内径高'"
            prop="containerHeight"
          >
            <el-input-number
              clearable
              v-model="formData.containerHeight"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width:100%;"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{span: 24}" :md="{span: 6}" :lg="{span: 12}">
          <el-form-item
            :label="$l('form_label_containerVolume') || '内容积'"
            prop="containerVolume"
          >
            <el-input-number
              clearable
              v-model="formData.containerVolume"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              :precision="2"
              :step="1"
              controls-position="right"
              disabled
              style="width:100%;"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 6}" :lg="{span: 12}">
          <el-form-item :label="$l('form_label_loadVolume') || '装载体积'">
            <el-input-number
              clearable
              v-model="formData.loadVolume"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width:100%;"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{span: 24}" :md="{span: 6}" :lg="{span: 12}">
          <el-form-item :label="$l('form_label_loadWeight') || '装载重量'">
            <el-input-number
              clearable
              v-model="formData.loadWeight"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width:100%;"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    containerCode: String,
    params: {type: Object, default: () => {}},
  },
  data() {
    return {
      formData: {},
      rules: {
        containerName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        containerDesc: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        containerLength: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        containerWidth: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        containerHeight: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.containerCode) return

      this.$api
        .masterContainerDetailApi({
          containerCode: this.containerCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.formData.containerVolume = this.formData.containerLength * this.formData.containerWidth * this.formData.containerHeight
      this.loadingOpen()
      this.$api
        .masterContainerSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
